import { render, staticRenderFns } from "./deviceinspectstandard.vue?vue&type=template&id=2b4c31f1&"
import script from "./deviceinspectstandard.vue?vue&type=script&lang=js&"
export * from "./deviceinspectstandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports